<template>
  <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
    <el-breadcrumb-item
      v-for="(n, i) in options"
      :key="i"
      :to="{ path: n.path }"
      >{{ n.name }}</el-breadcrumb-item
    >
  </el-breadcrumb>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    options: Array,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.breadcrumb {
  height: 20px;
  line-height: 20px;
  margin-bottom: 20px;
    
  /deep/ .el-breadcrumb__inner {
    margin: 0 5px 0 5px;
    &.is-link {
      font-weight: 500;
      color: #c0c4cc;
      &:hover {
        color: #2691ff;
      }
    }
  }
  
}

</style>

<style>
.breadcrumb .el-breadcrumb__item:last-child .is-link { color:#555;}
</style>